import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="account-tabs"
// Syncs the Bootstrap tab bar on /account with the URL hash (#wishlist / #orders / #profile)
export default class extends Controller {
  connect() {
    this.onHashChange = this.activateTabFromHash.bind(this)
    this.activateTabFromHash()
    window.addEventListener("hashchange", this.onHashChange)
  }

  disconnect() {
    window.removeEventListener("hashchange", this.onHashChange)
  }

  // data-action="shown.bs.tab->account-tabs#updateHash"
  updateHash(event) {
    const targetId = event.target.getAttribute("data-bs-target").substring(1)
    history.replaceState(null, null, `#${targetId}`)
  }

  activateTabFromHash() {
    const hash = window.location.hash
    if (!hash) return

    const tabButton = this.element.querySelector(`button[data-bs-target="#${CSS.escape(hash.substring(1))}"]`)
    if (tabButton) {
      new window.bootstrap.Tab(tabButton).show()
    }
  }
}
